import {HoistModel, managed, XH} from '@xh/hoist/core';
import {DashContainerModel} from '@xh/hoist/desktop/cmp/dash';
import {stockChartWidget} from './widgets/stockChart/StockChartWidget';
import {Icon} from '@xh/hoist/icon';
import {action, observable} from '@xh/hoist/mobx';
import {level2Widget} from './widgets/level2/Leve2Widget';
import {lineColumnsIcon} from '../../../core/Icons';

export class ChartsTabModel extends HoistModel {
    /**
     * Ticker shown by the main chart - the sync point between the router (i.e. "Send to Chart"
     * actions elsewhere in the app), the main chart itself, and any charts linked to it.
     */
    @observable accessor mainChartTicker: string;
    @managed dashContainerModel: DashContainerModel = this.createDashModel();

    constructor() {
        super();

        // Track the ticker route param, firing immediately to catch both a deep-linked start and
        // the navigation that first activates this tab (and therefore constructs this model).
        this.addReaction({
            track: () => XH.routerState,
            run: state => {
                const ticker = state?.name === 'default.charts' ? state.params.ticker : null;
                if (ticker) this.setMainChartTicker(ticker);
            },
            fireImmediately: true
        });
    }

    @action
    setMainChartTicker(ticker: string) {
        this.mainChartTicker = ticker;
    }

    private createDashModel(): DashContainerModel {
        return new DashContainerModel({
            persistWith: {prefKey: 'chartsTabState'},
            showMenuButton: true,
            renameLocked: true,
            viewSpecs: [
                {
                    id: 'mainChart',
                    title: 'Main Chart',
                    icon: Icon.chartArea(),
                    unique: true,
                    allowRemove: false,
                    allowAdd: false,
                    allowRename: false,
                    content: stockChartWidget
                },
                {
                    id: 'chart',
                    title: 'Chart',
                    icon: Icon.chartLine(),
                    unique: false,
                    allowRename: false,
                    content: stockChartWidget
                },
                {
                    id: 'level2',
                    title: 'Level II Quotes',
                    icon: lineColumnsIcon(),
                    content: level2Widget
                }
            ],
            initialState: [
                {
                    type: 'row',
                    width: 100,
                    content: [{type: 'view', id: 'mainChart'}]
                }
            ]
        });
    }
}
